export var config: any = {

  apiUrl: '/api', // local,
  uploadUrl: '/upload/'

};
